export const defaultFlagValues = {
  /** Habilita e passa o link do vídeo de introdução */
  tutorialVideoUrl: "https://www.youtube.com/embed/_Th1iWyN9T8?si=Dqo9wBccqisbJvny",
  /** Habilita o alerta de documento read only */
  warnReadOnlyDocument: false,
  /** Url do WhatsApp para iniciar uma conversa com CS */
  customerServiceWhatsApp: "",
  /** Habilita a funcionalidade de buscar jurisprudência */
  jurisprudenceSearch: true,
  /** Habilita o Indique e Ganhe  */
  membergetmemberEnabled: false,
  /** Habilita novo card da ação sugerida com valores (créditos) */
  newActionCardWithCreditAmountEnabled: false,
  /** Mostra o plano basic pre selecionado na tela de pagamento*/
  preSelectedBasicPlan: false,
  /** Habilita a edição de documentos com formatação (HTML) no editor */
  formattedEditionEnabled: true,
  /** Habilita o chat tawk para todos os usuários */
  tawkForAllUsers: true,
  /** Habilita o reenvio de convite*/
  resendReferralEnabled: false,
  /** Habilita nova tela do Assistente WhatsApp */
  whatsAppAssistantEnabled: true,
  /** Habilita o plano essencial */
  unlimitedPlanEnabled: true,
  /** Habilita a exibição do fluxo de onboarding para novos usuários */
  showOnboarding: false,
  /** Habilita a página de sucesso após criação de peça */
  successPageAfterCreationOfPiece: true,
  /** Habilita a ocultação de campos opcionais de skills */
  hideOptionalSkillFields: true,
  /** Habilita inside sales */
  insideSalesEnabled: false,
  /** Habilita apenas o plano essencial para compra */
  onlyUnlimitedPlanEnabled: true,
  /** Habilita o trial para o plano ilimitado */
  trialForUnlimitedPlanEnabled: true,
  /** Habilita os novos planos profissional e performance na tela de planos*/
  newPlansEnabled: false,
  /** Habilita os novos planos profissional e performance no checkout */
  newPlansInCheckoutEnabled: false,
  /** Habilita a funcionalidade de testes de novas skills */
  skillBetaTester: false,
  /** Links do inside sales */
  insideSalesLinks: {
    speakWithSpecialistNow: "https://meet.google.com/omb-mrzr-qtd",
    schedule: "https://calendly.com/carlos-vieira-lexter/30min",
    whatsapp: "https://wa.me/5582987123045",
  },
  /** Habilita a funcionalidade de busca de skills no skill group */
  skillGroupSearchEnabled: true,
  /** Cupom do plano essencial */
  essentialPlanCoupon: "30lexter",
  /** Habilita o numero de telefone no cadastro com google */
  phoneInSignUpWithGoogleEnabled: true,
  /** Habilita a funcionalidade de proximas etapas no caso */
  caseNextStepsEnabled: true,
  /** Petição Inicial (Sem arquivos de provas) */
  skillInitialPetitionV1Enabled: false,
  /** Petição Inicial (Com arquivos de provas) */
  skillInitialPetitionV2Enabled: true,
  /** Habilita a opção carf na busca de jurisprudência */
  searchPrecedentCarfEnabled: false,
  /** Habilita a página de processos legais */
  legalProceedingsPageEnabled: true,
  /** Habilita a exibição de sugestões de passos no caso */
  caseSuggestionsEnabled: true,
  /** Habilita gestão de atendimento no whatsapp. "Tickets" */
  whatsappTicketsEnabled: true,
  /** Habilita o modo de desenvolvimento */
  devModeEnabled: false,
  /** Habilita a funcionalidade de multiplos usuários */
  multipleUsers: true,
  /** Habilita as novas telas do assistente */
  newAssistentScreensEnabled: true,
  /** Habilita a nova página de casos */
  newCasesPageEnabled: true,
  /** Habilita a criação de caso por CNJ */
  createCaseByCnjEnabled: true,
  /** Habilita a nova tela de criação de caso */
  newCaseCreationScreenEnabled: false,
  /** Habilita a nova tela de planos */
  planScreenV2Enabled: true,
  /** Habilita a validação de quota de casos */
  shouldValidateCasesQuota: true,
  /** Habilita a nova tela de histórico de uso */
  newUsageHistoryScreen: true,
  /** Habilita réplica sem evidências */
  skillCreateReplyV1Enabled: false,
  /** Habilita defesa sem evidências */
  skillCreateDefenseV1Enabled: false,
  /** Habilita outro tipo de peça sem evidências */
  skillOtherTypeOfPieceV1Enabled: false,
  /** Habilita reclamação trabalhista sem evidências */
  skillCreateLaborComplaintV1Enabled: false,
  /** Habilita réplica com evidências */
  skillCreateReplyV2Enabled: true,
  /** Habilita defesa com evidências */
  skillCreateDefenseV2Enabled: true,
  /** Habilita outro tipo de peça com evidências */
  skillOtherTypeOfPieceV2Enabled: true,
  /** Habilita reclamação trabalhista com evidências */
  skillCreateLaborComplaintV2Enabled: true,
  /** Habilita o Cloud Humans */
  cloudHumansChatEnabled:
    "TRIAL,FREEMIUM,INITIAL,BASIC,INTERMEDIARY,ADVANCED,PROFESSIONAL,CUSTOM,UNLIMITED,PROFESSIONAL_WITH_WPP,PERFORMANCE",
  /** Habilita a funcionalidade de upload de arquivos */
  fileSignAndUpload: false,
  /** Habilita a nova tela de histórico de uso */
  newUsageHistoryV2: true,
  /** Habilita etiqueta de ativo no requerente */
  applicantActivationEnabled: true,
  /** Habilita widget de track de funil do caso */
  caseSituationEnabled: true,
  /** Habilita o serviço de aprovação de requisições */
  approvalRequestsEnabled: false,
  /** Habilita o botão para iniciar um agente de whatsapp */
  startWhatsappAgentEnabled: true,
  /** Habilita customer help chat */
  customerHelpChatEnabled: true,
  /** Habilita o agente de contrato */
  startContractAgentEnabled: true,
};
